export const getCookie = cookieName =>
  document?.cookie?.split(';')?.find(cookie => cookie.trim().startsWith(`${cookieName}=`));

export const formatPrice = (price = '') =>
  new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })
    .format(price)
    .replace(/,/g, '');

export const formatEven = price => formatPrice(Math.ceil(price)).replace(/\.[0-9]{2}/, '');

export const formatPhoneNumber = ({ phoneNumberString, phoneRef }) => {
  // TODO - extract this into a helper/utils fn
  const cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  let formattedNum = cleaned;
  const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);

  // if phone number is complete or has +1 return formatted with parenthesis
  // otherwise return formatted phone number with dashes
  if (match && !!phoneRef?.current) {
    const intlCode = match[1] ? '+1' : '';
    phoneRef.current.value = [intlCode, '(' + match[2] + ')', '-', match[3], '-', match[4]].join(
      ''
    );
    // return for initial form values
    return [intlCode, '(' + match[2] + ')', '-', match[3], '-', match[4]].join('');
  }
  // else
  if (cleaned.length > 3 && cleaned.length < 4) {
    formattedNum = cleaned + '-';
  } else if (cleaned.length >= 4 && cleaned.length <= 6) {
    formattedNum = cleaned.slice(0, 3) + '-' + cleaned.slice(3, 6);
  } else if (cleaned.length > 6) {
    formattedNum = cleaned.slice(0, 3) + '-' + cleaned.slice(3, 6) + '-' + cleaned.slice(6);
  }
  if (phoneRef?.current) {
    phoneRef.current.value = formattedNum;
  }
  // return for initial form values
  return formattedNum;
};

/**
 * takes in an array of addOns and extracts the outright and monthly price totals for all selected addOns
 * @param {array} addOns
 * @returns {object} { monthly: number, outright: number }
 */
export const getSelectedAddOnsPriceTotals = addOns => {
  return addOns.reduce(
    (total, addOn) => {
      if (addOn.selected) {
        total.monthly += addOn.monthlyPrice;
        total.outright += addOn.price;
      }
      return total;
    },
    { monthly: 0, outright: 0 }
  );
};
